import React, { useState, useEffect } from 'react';
import { Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography, Grid, Pagination, Container, Card, Button, LinearProgress, CircularProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { BsJustify } from 'react-icons/bs';
import TextField from '@mui/material/TextField';
import toast from 'react-hot-toast';
import EditIcon from '@mui/icons-material/Edit';
import LeadService from '../../core/services/leadsService';
import { Autocomplete } from '@mui/material';

const EditAdminVersion = ({ selectedEditId, open, setOpen ,getVersion, searchTerm}) => {
    const [versionInputField, setVersionInputField] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [selectedFilterValue, setSelectedFilterValue] = useState('');
    const [selectedForceValue, setSelectedForceValue] = useState(0);
    const handleClose = () => {
        setOpen(false);
        setVersionInputField('');
        setSelectedForceValue('');
        setSelectedFilterValue('');
    };

    const GetVersionForEdit = async () => {
        
        try {
            setLoading(true);
            const resp = await LeadService.GetVersionForEdit(selectedEditId);
            if (resp?.data?.success) {
                setVersionInputField(resp?.data?.version?.version);
                setSelectedFilterValue(resp?.data?.version?.platform);
                setSelectedForceValue(resp?.data?.version?.is_mandatory);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (selectedEditId && open) {
            GetVersionForEdit(selectedEditId);
        }
    }, [selectedEditId, open]);
    const filterOptions = [
        { value: 'ios_customer_app', label: 'IOS Customer App' },
        { value: 'ios_agent_app', label: 'IOS Agent App' },
        { value: 'android_customer_app', label: 'Android Customer App' },
        { value: 'android_agent_app', label: 'Android Agent App' },
    ];

    const hardForceOptions = [
        { value: 1, label: 'Mandatory' },
        { value: 0, label: 'Optional ' },
    ];

    const HandleChangeFilter = (event, newValue) => {
        setSelectedFilterValue(newValue ? newValue.value : '');
    };

    const HandleChangeHardForceOptions = (event, newValue) => {
        if (newValue) {
            setSelectedForceValue(newValue?.value);
        }
    };

    const handleUpdateVersion = async () => {
        try {
            setIsLoading(true);
            const resp = await LeadService.UpdateVersion(selectedEditId, versionInputField, selectedFilterValue, selectedForceValue);
            if (resp?.data?.success) {
                toast.success(resp?.data?.message);
                getVersion(searchTerm);
                handleClose();
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
            <Modal open={open}>
                <Box
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: '#fff',
                        padding: '20px',
                        borderRadius: '10px',
                        width: '558px',
                        height: 'auto',
                    }}
                >
                    <IconButton style={{ position: 'absolute', top: '10px', right: '10px' }} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                    <Box style={{ display: 'grid', padding: '20px', justifyContent: 'center' }}>
                        {Loading ? (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: 'auto',
                                }}
                            >
                                <CircularProgress />
                            </div>
                        ) : (
                            <>
                                <Box style={{ display: 'flex' }}>
                                    {/* {/ <ManageAccountsIcon /> /} */}
                                    <Typography
                                        style={{
                                            fontSize: '18px',
                                            color: '#252F46',
                                            fontWeight: '700',
                                        }}
                                    >
                                        Version
                                    </Typography>
                                </Box>
                                <Box style={{ display: 'grid', marginTop: '10px' }}>
                                    <TextField
                                        fullWidth
                                        multiline
                                        value={versionInputField}
                                        onChange={(event, value) => setVersionInputField(event.target.value)}
                                        placeholder="Version"
                                        style={{
                                            fontSize: '10px',
                                            color: '#6E757C',
                                        }}
                                        InputProps={{
                                            style: {
                                                height: '63px',
                                                width: '416px',
                                            },
                                        }}
                                    />
                                    <Typography style={{ fontSize: '12px', color: 'gray' }}>
                                    The version should be in the following format: e.g., v1.2 (1), v3.2 (2)
                                    </Typography>
                                </Box>
                                <Box style={{ display: 'flex', marginTop: '10px' }}>
                                    <Typography
                                        style={{
                                            fontSize: '18px',
                                            color: '#252F46',
                                            fontWeight: '700',
                                        }}
                                    >
                                        Platform
                                    </Typography>
                                </Box>
                                <Box style={{ marginTop: '10px' }}>
                                    <Autocomplete
                                        options={filterOptions}
                                        getOptionLabel={(filterOptions) => filterOptions.label}
                                        renderInput={(params) => <TextField {...params} label="Platform" />}
                                        value={filterOptions.find((filterOptions) => filterOptions.value === selectedFilterValue) || null}
                                        onChange={HandleChangeFilter}
                                        disabled={isLoading}
                                    />
                                </Box>
                                <Box style={{ display: 'flex', marginTop: '10px' }}>
                                    <Typography
                                        style={{
                                            fontSize: '18px',
                                            color: '#252F46',
                                            fontWeight: '700',
                                        }}
                                    >
                                        Force Update
                                    </Typography>
                                </Box>
                                <Box style={{ marginTop: '10px' }}>
                                    <Autocomplete
                                        options={hardForceOptions}
                                        getOptionLabel={(hardForceOptions) => hardForceOptions.label}
                                        renderInput={(params) => <TextField {...params} label="Option" />}
                                        value={hardForceOptions.find((option) => option.value === selectedForceValue) || null}
                                        onChange={HandleChangeHardForceOptions}
                                        disabled={isLoading}
                                    />
                                </Box>
                            </>
                        )}

                        <Box style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                            <Box>
                                <Button
                                    onClick={handleClose}
                                    sx={{
                                        width: '148px',
                                        height: '43px',
                                        backgroundColor: 'white',
                                        color: '#252F46',
                                        borderRadius: '12px',
                                        textTransform: 'capitalize',
                                        fontSize: 'auto',
                                        border: '1px solid #252F46',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                        fontFamily: 'inherit',
                                    }}
                                >
                                    {' '}
                                    Cancel
                                </Button>
                            </Box>

                            <Box>
                                <Button
                                    onClick={handleUpdateVersion}
                                    variant="contained"
                                    sx={{
                                        width: '148px',
                                        height: '43px',
                                        borderRadius: '12px',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                        border: '1px solid #587DBF',
                                        backgroundColor: '#5379BD',
                                        textTransform: 'capitalize',
                                        color: 'white',
                                        fontFamily: 'inherit',
                                    }}
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Loading...' : 'Save'}
                                </Button>
                                <LinearProgress sx={{ visibility: isLoading ? '' : 'hidden' }} />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

export default EditAdminVersion;
